// Single source of truth for announcement status/kind labels and their
// semantic color "tone" — shared by AnnouncementBar, HomeAnnouncements, the
// /announcements hub and AnnouncementDetail (all via AnnouncementCard).
// Tones map to the `.ve-tone-*` classes in announcements/tone.css, which
// read the actual color values from tokens.css.

export const STATUS_META = {
  open: { label: 'Open now', tone: 'success' },
  closing_soon: { label: 'Closing soon', tone: 'warning' },
  upcoming: { label: 'Opens soon', tone: 'info' },
  closed: { label: 'Closed', tone: 'neutral' },
};

export function getStatusMeta(status) {
  return STATUS_META[status] || null;
}

// Kind → tone per the P14 spec: alert -> danger, deadline -> warning,
// scholarship -> success, intake/event/news -> brand.
export const KIND_META = {
  intake: { label: 'Intake', tone: 'brand' },
  event: { label: 'Event', tone: 'brand' },
  news: { label: 'News', tone: 'brand' },
  scholarship: { label: 'Scholarship', tone: 'success' },
  deadline: { label: 'Deadline', tone: 'warning' },
  alert: { label: 'Alert', tone: 'danger' },
};

export function getKindMeta(kind) {
  return KIND_META[kind] || KIND_META.news;
}
